module.exports = __webpack_public_path__ + "static/img/cont33_03.ff47522.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont33_03.jpg
// module id = V0r6
// module chunks = 0